import React from 'react';

import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DefaultNoOptionsMessageContainer } from './DefaultNoOptionsMessage.style';

export const DefaultNoOptionsMessage = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <DefaultNoOptionsMessageContainer>
      <Typography variant="t14r" sx={{ color: theme.palette.case.neutral.n500 }}>
        {t('network.noOptions')}
      </Typography>
    </DefaultNoOptionsMessageContainer>
  );
};
